/**
 * Prevent injection attacks by checking for illegal characters at the start of the string.
 * Rule characters derived from AN-1924.
 *
 * @param {string} input
 * @returns {boolean}
 */
export default (input: string): boolean => {
  if (input.length === 0) return true;
  return /^[^=+\t\r\-@\s]+$/.test(input[0]);
};
